/* eslint-disable no-undef */
module.exports = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1030,
    xl: 1200,
    xxl: 1400,
};
